var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.directionsOfUse)?_c('div',{staticClass:"directions-of-use"},[_c('summary-direction-of-use-tab',{staticClass:"directions-of-use__summary",attrs:{"directions-of-use":_vm.directionsOfUse}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }